export default "__VITE_ASSET__DwThL3n4__"